import { lazy } from 'react';
import Loadable from '../../components/Loadable';

const PaidReceipt = Loadable(lazy(() => import('./PaidReceipt')));
const PodSendToParty = Loadable(lazy(() => import('./PodSendToParty')));
const PodStatementReport = Loadable(lazy(() => import('./PodStatementReport')));

const ReportRoutes = [
  { path: '/paidreceipt', element: <PaidReceipt /> },
  { path: '/podsendtoparty', element: <PodSendToParty /> },
  { path: '/podstatementreport', element: <PodStatementReport /> },
];

export default ReportRoutes;
